import React, { Component } from 'react';

import { StepWrapper } from '../styles';
import {
	ProgressWrapper,
	ProgressBarLabel,
	ProgressBarBackground,
	ProgressBarMarker,
	EtlProgressLabel,
	TimeRequired,
} from './styles';

export default class UploadProgressBar extends Component {
	render() {
		const { label, value, etl, timeRequired } = this.props;

		return (
			<StepWrapper>
				<ProgressWrapper timeRequired={timeRequired}>
					{etl ? (
						<EtlProgressLabel>{label}</EtlProgressLabel>
					) : (
						<ProgressBarLabel>{label}</ProgressBarLabel>
					)}
					<ProgressBarBackground>
						<ProgressBarMarker style={{ width: `${value}%` }} />
					</ProgressBarBackground>
					{timeRequired && (
						<TimeRequired>
							Total processing time depends on unique vendor count, file
							complexity, Azure connectivity and other parameters. For your
							reference, a file with 10k unique vendor count requires 4-6 hours
							to process end to end.
						</TimeRequired>
					)}
				</ProgressWrapper>
			</StepWrapper>
		);
	}
}
